import {Component, OnInit} from '@angular/core';
import { Location } from '@angular/common';
import {RecentProjectsService} from "./recent-projects.service";
import { Router } from '@angular/router';
import { SucursalRol  } from 'app/core/model/classes/sucursalRol';
import { config } from 'app/shared/smartadmin.config';

@Component({
  selector: 'sa-recent-projects',
  templateUrl: './recent-projects.component.html',
  providers: [RecentProjectsService]
})
export class RecentProjectsComponent implements OnInit {

  projects: Array<any>;
  sucursales: SucursalRol[] = [];
  // procesos = Object.keys(config.proceso);

  constructor(
    private router: Router,
    private projectsService: RecentProjectsService,
    private location: Location) {
       this.router.routeReuseStrategy
        .shouldReuseRoute = function(){
          return false;
        };
  }

  ngOnInit() {
    this.sucursales = JSON.parse(localStorage.getItem('sucursales'));
    // this.projects = this.projectsService.getProjects()
  }

  clearProjects(){
    // this.projectsService.clearProjects();
    // this.projects = this.projectsService.getProjects()

  }

  CambiaSucursal(idSucursal: number) {

    if (this.sucursales && this.sucursales.length > 0) {
      const sucursal = this.sucursales.filter(s => s.sucursal.idSucursal == idSucursal);

      if (sucursal && sucursal.length > 0) {
        localStorage.setItem('sucursalRol', JSON.stringify(sucursal[0]));
        //this.projectsService.redirectTo();
        this.router.navigate(['/home']);
        //this.location.go(this.router.url);
        //console.log('Cambiada:', sucursal[0]);
        //this.router.navigate(['/auth/login']);
      }

    }
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/recent-projects/recent-projects.component.ts